<template>
  <div class="diagnostics-files">
    <notification/>
    <div class="row align-items-center justify-content-between">
      <div class="col-auto">
        <h2 class="profile__header">{{ $t('visits.diagnostics_files') }}</h2>
      </div>
      <div class="col-auto">
        <router-link :to="{ name: 'profile.visits.past.diagnostics' }" class="btn-gray-border w-auto m-0">
          {{ $t('visits.diagnostics') }}
        </router-link>
      </div>
    </div>
    <div class="loaded" v-if="loaded">{{ $t('diagnostic_files.loading_in_progress') }}</div>
    <div v-else>
      <div class="empty-files" v-if="diagnosticFiles.length <= 0">{{ $t('diagnostic_files.not_found_files') }}</div>
      <div class="diagnostics-files-table" v-else>
        <div class="diagnostics-files-table-head">
          <div class="row no-gutters">
            <div class="col-3">
              <p>{{ $t('diagnostic_files.table.files_date') }}</p>
            </div>
            <div class="col-4">
              <p class="title">{{ $t('diagnostic_files.table.files_title') }}</p>
            </div>

          </div>
        </div>
        <div class="diagnostics-files-table-body">
          <div class="row no-gutters align-items-center diagnostics-file" v-for="(file, index) in diagnosticFiles"
            :key="index">
            <div class="col-3 diagnostics-file-date">
              <p>{{ file.study_date | dateFormat }}</p>
            </div>
            <div class="col-4 diagnostics-file-title">
              <p>
                {{ file.study_name ? file.study_name : $t('empty_name') }}</p>
            </div>

            <div class="col-2 text-center diagnostics-file-timer">
              <countdown :deadline="file.endTime" :counter-id="index" v-if="file.endTime" @timer-end="timerEnd">
              </countdown>
            </div>
            <div class="col-3 diagnostics-file-buttons justify-content-between" v-if="file.process === 'no-started'">
              <button class="btn" @click="getFiles(file.study_uid, index)" :disabled="atLeastOneFileInProgress">{{ $t('buttons.request_result') }}</button>
            </div>
            <div class="col-3 diagnostics-file-buttons justify-content-between" v-else-if="file.process === 'pending'">
              <button class="btn btn-blue-sky-progress">{{
                  $t('buttons.processed')
              }}
              </button>
            </div>
            <div class="col-3 diagnostics-file-buttons justify-content-between" v-else-if="file.process === 'done'">
              <button :data-coppy="`${baseUrl}/dcim/${file.study_uid}.zip`" class="mini-btn btn-blue-sky" @click="copy">
                {{
                    $t('buttons.сopy_link')
                }}
              </button>
              <a :href="`${baseUrl}/dcim/${file.study_uid}.zip`" download class="mini-btn btn-blue-sky">{{
                  $t('buttons.download')
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" centered hide-footer :title="$t('diagnostic_files.modal.title')"
        modal-class="modal-files-info">
        <div class="container">
          <p class="text-center m-0">{{ $t('diagnostic_files.modal.text') }}</p>
        </div>

      </b-modal>
    </div>
  </div>
</template>

<script>
import Countdown from "../../components/Countdown";
import { mapGetters } from 'vuex';
import moment from 'moment';
import config from '@/helpers/configDateFormats';
import Notification from '@/components/Notification'


// statuses process pending, done, no-started

export default {
  name: "DiagnosticsPastFiles",
  components: {
    Countdown,
    Notification,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      showModal: false,
      loaded: true,
      intervalId: ''
    }
  },
  watch: {
    diagnosticFiles: {
      handler: function (val) {
        if (val.filter(item => item.process === 'pending').length > 0) {
          this.chekingStatusForPending();
        } else {
          clearInterval(this.intervalId)
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      diagnosticFiles: 'diagnosticFiles',
    }),
    atLeastOneFileInProgress() {
      return this.diagnosticFiles ? this.diagnosticFiles.filter(item => item.process === 'pending').length > 0 : false;
    },
  },
  methods: {
    timerEnd(id) {
      this.$store
        .dispatch('timerEnd', { index: id })
    },
    getFiles(uid, index) {
      this.$store
        .dispatch('getDiagnosticFile', { uid }).then(data => {
          this.$store
            .dispatch('setProcessedByIndex', { index })
        }).catch(er => console.error(er));
      
      this.showNotification();
      
    },
    copy(e) {
      this.$copyText(e.target.getAttribute('data-coppy')).then(function (e) {
        console.log(e)
      }, function (e) {
        console.log(e)
      })
    },
    checkFileListForStatus(status) {
      if (this.diagnosticFiles.filter(item => item.process === status).length > 0) {
        return true
      }
      return false
    },
    chekingStatusForPending() {
      if (!this.checkFileListForStatus('pending')) {
        clearInterval(this.intervalId)
        return
      }
      this.intervalId = setInterval(() => {
        let fileListOnPending = this.diagnosticFiles.filter(item => item.process === 'pending');
        this.$store
          .dispatch('checkStatusForPending', { data: fileListOnPending }).then(e => {
            if (e) {
              this.showModal = true;
            }
          })
      }, 5000)

    },
    showNotification() {
       this.$notify({  
          //title: "<span class='material-icons'>info_outline</span>",
          text:  "<i class='material-icons'>info_outline</i>" + this.$t('diagnostic_files.info_msg'),
       })
    }
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format(config.DATE_FORMAT);
    }
  },

  mounted() {
    this.$store
      .dispatch('getDiagnosticFilesList').then(e => {
        this.loaded = false
        this.chekingStatusForPending();
      });

  },
}
</script>
<style lang="scss" scoped>
@import "../../assets/scss/utils/variables";

.diagnostics-files {
  .empty-files {
    color: $font-color;
  }

  &-table {
    &-head {
      padding: 25px 0px;

      p {
        font-family: $font-family-bold;
        font-size: 12px;
        line-height: 1.2;
        color: $link-shadow;
        margin: 0;

      }
    }

    &-body {
      .diagnostics-file {
        border-top: 1px solid $link-shadow;
        border-bottom: 1px solid $link-shadow;
        padding: 15px 0;
        margin-bottom: 15px;

        &-timer {
          .countdown-timer {
            margin-top: 10px;
          }
        }

        p {
          margin: 0;
          font-family: $font-family;
          font-size: 18px;
          line-height: 1.2;

        }

        &-buttons {
          display: flex;

          button {
            margin-bottom: 0;
          }

          .btn {
            height: 50px;
          }

          .mini-btn {
            width: calc(50% - 7.5px);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }


}

.my-tooltip {
  position: absolute;
  bottom: 0;
  width: calc(50% - 7.5px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f8fa;
  border-radius: 5px;
  font-size: 10px;
  padding: 5px;
  line-height: 1.1;
  text-align: center;
  transform: translate(0px, calc(100% + 10px));

  p {
    margin: 0;

  }

  &:after {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
  }
}

/deep/ .modal-files-info {
  .modal-header {
    border-bottom: none;


    .modal-title {
      margin-left: auto;
      color: $font-color;
      font-family: $font-family-bold;
      font-size: 18px;
      line-height: 1.2;
    }
  }

  .modal-body {
    padding-top: 0;

    p {
      font-family: $font-family;
      font-size: 18px;
      line-height: 1.2;
    }
  }
}
</style>

